<template>
  <!-- Spinner Start -->
  <!-- <div id="spinner" class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div> -->
<!-- Spinner End -->

<!-- Topbar Start -->
<div class="container-fluid px-5 d-none d-lg-block" style="background-color: #077747 !important;">
  <div class="row gx-0">
      <div class="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
          <div class="d-inline-flex align-items-center" style="height: 45px;">
              <a class="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href=""><i class="fab fa-twitter fw-normal"></i></a>
              <a class="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="https://www.facebook.com/systemcaredigital"><i class="fab fa-facebook-f fw-normal"></i></a>
              <a class="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="https://www.linkedin.com/company/systemcaredigital/"><i class="fab fa-linkedin-in fw-normal"></i></a>
              <a class="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href="https://instagram.com/systemcaredigital"><i class="fab fa-instagram fw-normal"></i></a>
              <a class="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href=""><i class="fab fa-youtube fw-normal"></i></a>
          </div>
      </div>
      <div class="col-lg-4 text-center text-lg-end">
        <div class="d-inline-flex align-items-center" style="height: 45px;">
            <!-- <a href="#"><small class="me-3 text-light"><i class="fa fa-user me-2"></i>Register</small></a> -->
            <!-- <a href="#"><small class="me-3 text-light"><i class="fa fa-sign-in-alt me-2"></i>Login</small></a> -->

          <div class="dropdown">
            <a href="#" class="dropdown-toggle text-light" data-bs-toggle="dropdown">
              <i class="fa-solid fa-globe me-1"></i>
              <span>{{ selectedLanguage }}</span> <!-- Display the selected language here -->
            </a>&nbsp;
            <div class="dropdown-menu rounded">
              <a href="#" class="dropdown-item" @click.prevent="setLanguage('en')">
                <i class="fa-solid fa-flag-usa"></i> English
              </a>
              <a href="#" class="dropdown-item" @click.prevent="setLanguage('bn')">
                <i class="fas fa-comment-alt me-2"></i> Bangla
              </a>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>
<!-- Topbar End -->

<!-- Navbar & Hero Start -->
<div class="container-fluid position-relative p-0">
  <nav class="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
      <a href="/" class="navbar-brand p-0">
<!--          <h1 class="m-0"><i class="fa fa-map-marker-alt me-3"></i>Wasiyyah</h1>-->
        <img src="@/assets/images/Al_Wasiyyat_LogoN.png" alt="Wasiyyah Logo">
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
              <span class="fa fa-bars"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarCollapse">
          <div class="navbar-nav ms-auto py-0">
            <router-link to="/" class="nav-item nav-link">{{ $t('Home') }}</router-link>
            <router-link to="/calculation" class="nav-item nav-link">{{ $t('Property Calculator') }}</router-link>
              <router-link to="about-us" class="nav-item nav-link">{{ $t('About Us') }}</router-link>
              <router-link to="blog-post" class="nav-item nav-link">{{ $t('Pages') }}</router-link>
              <!-- <a href="blog.html" class="nav-item nav-link">Blog</a> -->
              
            <router-link to="contact-us" class="nav-item nav-link">{{ $t('Contact Us') }}</router-link>
<!--              <a href="contact.html" class="nav-item nav-link">Contact</a>-->
          </div>
          <a href="https://app.wasiyyat.com" target="_blank" class="btn btn-success rounded-pill py-2 px-4 ms-lg-4">{{ $t('Create Now') }}</a>
      </div>
  </nav>
</div>
<!-- Navbar & Hero End -->

<!-- Header End -->
<div class="main-container p-3">
  <router-view/>
</div>

    <!-- Footer Start -->
<div class="container-fluid footer py-5">
  <div class="container py-5">
      <div class="row g-5">
          <div class="col-md-8 col-lg-8 col-xl-4">
              <div class="footer-item d-flex flex-column">
                  <h4 class="mb-4 text-white">{{ $t('Get In Touch') }}</h4>
                  <a href=""><i class="fas fa-home me-2"></i> {{ $t('location') }}</a>
                  <a href=""><i class="fas fa-envelope me-2"></i> info@systemcaredigital.com</a>
                  <a href=""><i class="fas fa-phone me-2"></i> {{ $t('telephone') }}</a>
                  <a href="" class="mb-3"><i class="fas fa-print me-2"></i> {{ $t('mobile') }}</a>
                  <div class="d-flex align-items-center">
                      <i class="fas fa-share fa-2x text-white me-2"></i>
                      <a class="btn-square btn btn-primary rounded-circle mx-1" href="https://www.facebook.com/systemcaredigital"><i class="fab fa-facebook-f"></i></a>
                      <a class="btn-square btn btn-primary rounded-circle mx-1" href=""><i class="fab fa-twitter"></i></a>
                      <a class="btn-square btn btn-primary rounded-circle mx-1" href="https://instagram.com/systemcaredigital"><i class="fab fa-instagram"></i></a>
                      <a class="btn-square btn btn-primary rounded-circle mx-1" href="https://www.linkedin.com/company/systemcaredigital/"><i class="fab fa-linkedin-in"></i></a>
                  </div>
              </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-3">
              <div class="footer-item d-flex flex-column">
                  <h4 class="mb-4 text-white">{{ $t('Company') }}</h4>
                  <a href="about-us"><i class="fas fa-angle-right me-2"></i> {{ $t('About Us') }}</a>
                  <a href="blog-post"><i class="fas fa-angle-right me-2"></i> {{ $t('Pages') }}</a>
                  <a href=""><i class="fas fa-angle-right me-2"></i> {{ $t('Press') }}</a>
              </div>
          </div>
          <div class="col-md-6 col-lg-6 col-xl-3">
              <div class="footer-item d-flex flex-column">
                  <h4 class="mb-4 text-white">{{ $t('Support') }}</h4>
                  <a href="contact-us"><i class="fas fa-angle-right me-2"></i> {{ $t('Contact Us') }}</a>
                  <a href="privacy-policy"><i class="fas fa-angle-right me-2"></i> {{ $t('Privacy Policy') }}</a>
                  <a href="terms-condition"><i class="fas fa-angle-right me-2"></i> {{ $t('Terms and Conditions') }}</a>
              </div>
          </div>
      </div>
  </div>
</div>
<!-- Footer End -->

<!-- Copyright Start -->
<div class="container-fluid copyright text-body py-4 mt-1">
    <div class="container">
      <div class="row justify-content-center align-items-center">
      <div class="col-12 text-center">
        <hr style="border-color: rgba(255, 255, 255, 0.1);" class="mb-3" />
        <p class="mb-0 text-white small">
          Copyright &copy; 2025 <a href="#" class="text-primary text-decoration-none">System Care Digital</a> | All Rights Reserved
        </p>
      </div>
    </div>
    </div>
  </div>
  <div class="top-up-down">
    <a href="#" class="btn btn-primary btn-md-square back-to-top float-end"><i class="fa fa-arrow-up"></i></a>
  </div>
<!-- Copyright End -->
</template>

<!--- <script>
import { ref } from 'vue';
import router from './router/routers';
import { useI18n } from 'vue-i18n';

export default {
  router,
  name: 'App',
  components: {},
  setup() {
    const { locale } = useI18n();
    const savedLocale = localStorage.getItem('locale') || 'en';
    locale.value = savedLocale;

    const setLanguage = (lang) => {
      locale.value = lang;
      localStorage.setItem('locale', lang);  
      selectedLanguage.value = lang === 'en' ? 'English' : 'Bangla';
    };

    const selectedLanguage = ref(savedLocale === 'en' ? 'English' : 'Bangla');

    console.log('language', selectedLanguage);
    
    return { setLanguage, selectedLanguage };
  }
}

</script>-->


<script>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import router from './router/routers';

export default {
  router,
  name: 'App',
  setup() {
    const { locale } = useI18n();
    const savedLocale = localStorage.getItem('locale') || 'en';
    locale.value = savedLocale;

    const selectedLanguage = ref(savedLocale === 'en' ? 'English' : 'Bangla');

    const setLanguage = (lang) => {
      if (lang !== locale.value) {
        locale.value = lang;
        localStorage.setItem('locale', lang);  
        selectedLanguage.value = lang === 'en' ? 'English' : 'Bangla';
        // Reload the page to apply the language change
        window.location.reload();
      }
    };

    // Watch for changes to the locale and trigger a reload if it changes
    watch(() => locale.value, (newLocale) => {
      localStorage.setItem('locale', newLocale);
      window.location.reload(); // Reload the page when the language is changed
    });

    return { setLanguage, selectedLanguage };
  }
};
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0%;
}
</style>
